import PartnerLogo, {constants as partnerLogoConstants} from '../../../Partner/Logo';
import PartnerRolesAndLevelsAll from '../../../Partner/RolesAndLevels/All';
import computeClassName from "../../../../../utils/computeClassName";

const constants = Object.freeze({
  CLASSNAME_BASE: ''
});

export default function PartnerLogoRolesAndLevels(
  {
    partnerBeGeoId,
    partnerRolesAndLevels,
    className,
  }
) {
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  return (
    <section className={computedClassName}>
      <header className="px-5 xs:px-0 xs:mx-auto xs:w-8/12">
        <PartnerLogo partnerBeGeoId={partnerBeGeoId}
                     displayContext={partnerLogoConstants.DISPLAY_CONTEXT_PARTNER_PROFILE}
                     className="mb-6"/>
        <PartnerRolesAndLevelsAll partnerRolesAndLevels={partnerRolesAndLevels}/>
      </header>
    </section>
  );
}
